import { render, staticRenderFns } from "./imagingReport.vue?vue&type=template&id=97080006&scoped=true"
import script from "./imagingReport.vue?vue&type=script&lang=js"
export * from "./imagingReport.vue?vue&type=script&lang=js"
import style0 from "./imagingReport.vue?vue&type=style&index=0&id=97080006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97080006",
  null
  
)

export default component.exports